<div><h1>Clone Issue</h1><LoaderOverlay :loading="loading"><IssueForm saveAction="clone"></IssueForm></LoaderOverlay></div>